// Module A1 — Đào tạo chuyên sâu (Training)

export type AircraftType = 'Su-30MK2' | 'Su-22M4' | 'Su-27' | 'MiG-21' | 'Yak-130' | 'L-39' | 'Mi-8' | 'Mi-17' | 'C-295'
export type TrainingCategory = 'Cơ bản' | 'Chuyển loại' | 'Tiến công' | 'Đêm' | 'Biên đội' | 'Khí tượng phức tạp' | 'Tiếp dầu' | 'Địa hình thấp'
export type StudentStatus = 'Đang học' | 'Tạm nghỉ' | 'Tốt nghiệp' | 'Đình chỉ' | 'Loại'
export type CourseStatus = 'Đang mở' | 'Sắp mở' | 'Đã kết thúc' | 'Hoãn'

export interface CurriculumModule {
  id: string
  code: string
  name: string
  hours: number
  sorties?: number
  outcomes: string[]
  prerequisite?: string
}

export interface Curriculum {
  id: string
  code: string
  name: string
  aircraftType: AircraftType
  level: 'Sơ cấp' | 'Trung cấp' | 'Cao cấp' | 'Chuyên gia'
  totalHours: number
  totalSorties: number
  durationMonths: number
  description: string
  modules: CurriculumModule[]
  certificateCode: string
  approvedBy: string
  approvedDate: string
  version: string
}

export const CURRICULA: Curriculum[] = [
  {
    id: 'CUR-001', code: 'CUR-SU30-CB', name: 'Chương trình huấn luyện cơ bản Su-30MK2', aircraftType: 'Su-30MK2', level: 'Sơ cấp',
    totalHours: 280, totalSorties: 96, durationMonths: 9, description: 'Đào tạo phi công cơ bản Su-30MK2 từ phi công đã có kỹ năng L-39/Yak-130.',
    certificateCode: 'CC-SU30-CB-2026', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2025-08-15', version: 'v3.2',
    modules: [
      { id: 'M-001', code: 'GD-LT', name: 'Giáo dục lý thuyết', hours: 60, outcomes: ['Hiểu cấu tạo máy bay', 'Hiểu hệ thống điện tử', 'Quy tắc bay'] },
      { id: 'M-002', code: 'MP-CB', name: 'Mô phỏng cơ bản', hours: 40, sorties: 16, outcomes: ['Cất hạ cánh ban ngày', 'Bay theo lộ trình', 'Xử lý tình huống bất thường'], prerequisite: 'M-001' },
      { id: 'M-003', code: 'BAY-CB', name: 'Bay cơ bản', hours: 80, sorties: 32, outcomes: ['Cất hạ cánh chuẩn', 'Bay vòng', 'Bay biên đội đôi'], prerequisite: 'M-002' },
      { id: 'M-004', code: 'BAY-DEM', name: 'Bay đêm', hours: 40, sorties: 16, outcomes: ['Cất hạ cánh đêm', 'Bay theo IFR'], prerequisite: 'M-003' },
      { id: 'M-005', code: 'BAY-CT', name: 'Bay chiến thuật', hours: 60, sorties: 32, outcomes: ['Tiến công không-đối-không', 'Tiến công không-đối-đất', 'Phòng tránh radar'], prerequisite: 'M-004' },
    ],
  },
  {
    id: 'CUR-002', code: 'CUR-SU22-CL', name: 'Chương trình chuyển loại Su-22M4', aircraftType: 'Su-22M4', level: 'Trung cấp',
    totalHours: 180, totalSorties: 64, durationMonths: 6, description: 'Chuyển loại từ MiG-21 sang Su-22M4.',
    certificateCode: 'CC-SU22-CL-2026', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2025-06-10', version: 'v2.5',
    modules: [
      { id: 'M-101', code: 'CL-LT', name: 'Lý thuyết chuyển loại', hours: 40, outcomes: ['Khác biệt MiG-21 vs Su-22'] },
      { id: 'M-102', code: 'CL-MP', name: 'Mô phỏng chuyển loại', hours: 30, sorties: 12, outcomes: ['Làm chủ buồng lái Su-22'], prerequisite: 'M-101' },
      { id: 'M-103', code: 'CL-BAY', name: 'Bay chuyển loại', hours: 60, sorties: 30, outcomes: ['Cất hạ cánh Su-22', 'Bay theo lộ trình'], prerequisite: 'M-102' },
      { id: 'M-104', code: 'CL-CT', name: 'Bay chiến thuật Su-22', hours: 50, sorties: 22, outcomes: ['Tiến công mặt đất', 'Phối hợp biên đội'], prerequisite: 'M-103' },
    ],
  },
  {
    id: 'CUR-003', code: 'CUR-MIG21-CB', name: 'Chương trình cơ bản MiG-21', aircraftType: 'MiG-21', level: 'Sơ cấp',
    totalHours: 220, totalSorties: 80, durationMonths: 8, description: 'Đào tạo phi công tiêm kích MiG-21.',
    certificateCode: 'CC-MIG21-CB-2025', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2024-12-20', version: 'v1.8',
    modules: [
      { id: 'M-201', code: 'MG-LT', name: 'Lý thuyết MiG-21', hours: 50, outcomes: ['Cấu tạo MiG-21'] },
      { id: 'M-202', code: 'MG-MP', name: 'Mô phỏng', hours: 30, sorties: 12, outcomes: ['Làm chủ MiG-21'] },
      { id: 'M-203', code: 'MG-BAY', name: 'Bay MiG-21', hours: 90, sorties: 40, outcomes: ['Bay cơ bản MiG-21'] },
      { id: 'M-204', code: 'MG-CT', name: 'Chiến thuật MiG-21', hours: 50, sorties: 28, outcomes: ['Tiến công không-đối-không'] },
    ],
  },
  {
    id: 'CUR-004', code: 'CUR-YAK130-CB', name: 'Chương trình cơ bản Yak-130', aircraftType: 'Yak-130', level: 'Sơ cấp',
    totalHours: 160, totalSorties: 56, durationMonths: 6, description: 'Đào tạo phi công cơ bản Yak-130 (huấn luyện trung gian).',
    certificateCode: 'CC-YAK130-2026', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2025-10-05', version: 'v1.3',
    modules: [
      { id: 'M-301', code: 'YK-LT', name: 'Lý thuyết Yak-130', hours: 40, outcomes: ['Cấu tạo'] },
      { id: 'M-302', code: 'YK-MP', name: 'Mô phỏng Yak-130', hours: 30, sorties: 12, outcomes: ['Làm chủ buồng lái'] },
      { id: 'M-303', code: 'YK-BAY', name: 'Bay Yak-130', hours: 60, sorties: 24, outcomes: ['Cất hạ cánh', 'Bay theo lộ trình'] },
      { id: 'M-304', code: 'YK-CT', name: 'Chiến thuật cơ bản', hours: 30, sorties: 20, outcomes: ['Bay biên đội'] },
    ],
  },
  {
    id: 'CUR-005', code: 'CUR-L39-CB', name: 'Chương trình cơ bản L-39', aircraftType: 'L-39', level: 'Sơ cấp',
    totalHours: 140, totalSorties: 50, durationMonths: 5, description: 'Đào tạo phi công vào nghề trên L-39.',
    certificateCode: 'CC-L39-2025', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2024-09-15', version: 'v2.1',
    modules: [
      { id: 'M-401', code: 'L39-LT', name: 'Lý thuyết L-39', hours: 35, outcomes: ['Lý thuyết bay'] },
      { id: 'M-402', code: 'L39-MP', name: 'Mô phỏng L-39', hours: 25, sorties: 10, outcomes: ['Làm quen buồng lái'] },
      { id: 'M-403', code: 'L39-BAY', name: 'Bay L-39', hours: 60, sorties: 28, outcomes: ['Bay cơ bản'] },
      { id: 'M-404', code: 'L39-NC', name: 'Bay nâng cao L-39', hours: 20, sorties: 12, outcomes: ['Bay đêm'] },
    ],
  },
  {
    id: 'CUR-006', code: 'CUR-MI17-CB', name: 'Chương trình cơ bản Mi-17', aircraftType: 'Mi-17', level: 'Sơ cấp',
    totalHours: 200, totalSorties: 70, durationMonths: 7, description: 'Đào tạo phi công trực thăng vận tải Mi-17.',
    certificateCode: 'CC-MI17-2026', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2025-04-22', version: 'v1.6',
    modules: [
      { id: 'M-501', code: 'MI-LT', name: 'Lý thuyết Mi-17', hours: 45, outcomes: ['Cấu tạo trực thăng'] },
      { id: 'M-502', code: 'MI-MP', name: 'Mô phỏng Mi-17', hours: 30, sorties: 14, outcomes: ['Làm chủ buồng lái'] },
      { id: 'M-503', code: 'MI-BAY', name: 'Bay Mi-17', hours: 80, sorties: 32, outcomes: ['Bay treo', 'Hạ cánh khẩn cấp'] },
      { id: 'M-504', code: 'MI-NV', name: 'Nhiệm vụ vận tải', hours: 45, sorties: 24, outcomes: ['SAR', 'Vận chuyển'] },
    ],
  },
  {
    id: 'CUR-007', code: 'CUR-C295', name: 'Chương trình cơ bản C-295', aircraftType: 'C-295', level: 'Trung cấp',
    totalHours: 240, totalSorties: 60, durationMonths: 8, description: 'Đào tạo phi công vận tải C-295.',
    certificateCode: 'CC-C295-2026', approvedBy: 'Tham mưu trưởng QC', approvedDate: '2025-02-18', version: 'v1.2',
    modules: [
      { id: 'M-601', code: 'C-LT', name: 'Lý thuyết C-295', hours: 60, outcomes: ['Hệ thống C-295'] },
      { id: 'M-602', code: 'C-MP', name: 'Mô phỏng C-295', hours: 40, sorties: 16, outcomes: ['Làm chủ buồng lái'] },
      { id: 'M-603', code: 'C-BAY', name: 'Bay C-295', hours: 80, sorties: 24, outcomes: ['Bay vận tải'] },
      { id: 'M-604', code: 'C-NV', name: 'Nhiệm vụ chuyên dụng', hours: 60, sorties: 20, outcomes: ['SIGINT', 'Tuần thám biển'] },
    ],
  },
]

export const CURRICULA_BY_ID = Object.fromEntries(CURRICULA.map((c) => [c.id, c]))

// =============== Courses (Khóa học) ===============

export interface Course {
  id: string
  code: string
  name: string
  curriculumId: string
  status: CourseStatus
  startDate: string
  endDate: string
  unitId: string
  unitName: string
  instructorIds: string[]
  studentIds: string[]
  totalSeats: number
  enrolledSeats: number
  progress: number
  passRate?: number
}

const STUDENT_IDS_BANK = Array.from({ length: 80 }, (_, i) => `STD-${String(i + 1).padStart(3, '0')}`)

export const COURSES: Course[] = [
  { id: 'CRS-001', code: 'K42-SU30', name: 'Khóa 42 — Su-30MK2 cơ bản', curriculumId: 'CUR-001', status: 'Đang mở', startDate: '2025-09-15', endDate: '2026-06-30', unitId: 'unit-tdb-1', unitName: 'Trung đoàn 923', instructorIds: ['INS-001', 'INS-002', 'INS-003'], studentIds: STUDENT_IDS_BANK.slice(0, 12), totalSeats: 12, enrolledSeats: 12, progress: 62 },
  { id: 'CRS-002', code: 'K12-SU22', name: 'Khóa 12 — Chuyển loại Su-22M4', curriculumId: 'CUR-002', status: 'Đang mở', startDate: '2025-11-01', endDate: '2026-04-30', unitId: 'unit-tdb-2', unitName: 'Trung đoàn 921', instructorIds: ['INS-004', 'INS-005'], studentIds: STUDENT_IDS_BANK.slice(12, 20), totalSeats: 8, enrolledSeats: 8, progress: 48 },
  { id: 'CRS-003', code: 'K38-MIG21', name: 'Khóa 38 — MiG-21 cơ bản', curriculumId: 'CUR-003', status: 'Đang mở', startDate: '2025-08-01', endDate: '2026-04-15', unitId: 'unit-tdb-3', unitName: 'Trung đoàn 925', instructorIds: ['INS-006', 'INS-007'], studentIds: STUDENT_IDS_BANK.slice(20, 30), totalSeats: 10, enrolledSeats: 10, progress: 71 },
  { id: 'CRS-004', code: 'K15-YAK130', name: 'Khóa 15 — Yak-130', curriculumId: 'CUR-004', status: 'Đang mở', startDate: '2025-10-10', endDate: '2026-04-10', unitId: 'unit-tdb-4', unitName: 'Trung đoàn 920', instructorIds: ['INS-008', 'INS-009'], studentIds: STUDENT_IDS_BANK.slice(30, 42), totalSeats: 12, enrolledSeats: 12, progress: 55 },
  { id: 'CRS-005', code: 'K28-L39', name: 'Khóa 28 — L-39 vào nghề', curriculumId: 'CUR-005', status: 'Đang mở', startDate: '2025-09-01', endDate: '2026-02-01', unitId: 'unit-tdb-4', unitName: 'Trung đoàn 920', instructorIds: ['INS-010', 'INS-011'], studentIds: STUDENT_IDS_BANK.slice(42, 56), totalSeats: 14, enrolledSeats: 14, progress: 78 },
  { id: 'CRS-006', code: 'K07-MI17', name: 'Khóa 7 — Mi-17 trực thăng', curriculumId: 'CUR-006', status: 'Đang mở', startDate: '2025-07-15', endDate: '2026-02-15', unitId: 'unit-tdb-5', unitName: 'Lữ đoàn 916', instructorIds: ['INS-012', 'INS-013'], studentIds: STUDENT_IDS_BANK.slice(56, 64), totalSeats: 8, enrolledSeats: 8, progress: 88 },
  { id: 'CRS-007', code: 'K03-C295', name: 'Khóa 3 — C-295 vận tải', curriculumId: 'CUR-007', status: 'Đang mở', startDate: '2025-06-01', endDate: '2026-02-01', unitId: 'unit-tdb-6', unitName: 'Lữ đoàn 918', instructorIds: ['INS-014', 'INS-015'], studentIds: STUDENT_IDS_BANK.slice(64, 70), totalSeats: 6, enrolledSeats: 6, progress: 92 },
  { id: 'CRS-008', code: 'K43-SU30', name: 'Khóa 43 — Su-30MK2 cơ bản', curriculumId: 'CUR-001', status: 'Sắp mở', startDate: '2026-09-15', endDate: '2027-06-30', unitId: 'unit-tdb-1', unitName: 'Trung đoàn 923', instructorIds: ['INS-001', 'INS-016'], studentIds: STUDENT_IDS_BANK.slice(70, 76), totalSeats: 12, enrolledSeats: 6, progress: 0 },
  { id: 'CRS-009', code: 'K39-MIG21', name: 'Khóa 39 — MiG-21 cơ bản', curriculumId: 'CUR-003', status: 'Sắp mở', startDate: '2026-08-01', endDate: '2027-04-15', unitId: 'unit-tdb-3', unitName: 'Trung đoàn 925', instructorIds: ['INS-006', 'INS-017'], studentIds: STUDENT_IDS_BANK.slice(76, 80), totalSeats: 10, enrolledSeats: 4, progress: 0 },
  { id: 'CRS-010', code: 'K41-SU30', name: 'Khóa 41 — Su-30MK2 cơ bản', curriculumId: 'CUR-001', status: 'Đã kết thúc', startDate: '2024-09-15', endDate: '2025-06-30', unitId: 'unit-tdb-1', unitName: 'Trung đoàn 923', instructorIds: ['INS-002', 'INS-003'], studentIds: STUDENT_IDS_BANK.slice(0, 11), totalSeats: 12, enrolledSeats: 12, progress: 100, passRate: 91.7 },
  { id: 'CRS-011', code: 'K11-SU22', name: 'Khóa 11 — Chuyển loại Su-22', curriculumId: 'CUR-002', status: 'Đã kết thúc', startDate: '2024-11-01', endDate: '2025-04-30', unitId: 'unit-tdb-2', unitName: 'Trung đoàn 921', instructorIds: ['INS-004'], studentIds: STUDENT_IDS_BANK.slice(12, 18), totalSeats: 8, enrolledSeats: 6, progress: 100, passRate: 83.3 },
  { id: 'CRS-012', code: 'K27-L39', name: 'Khóa 27 — L-39', curriculumId: 'CUR-005', status: 'Đã kết thúc', startDate: '2024-09-01', endDate: '2025-02-01', unitId: 'unit-tdb-4', unitName: 'Trung đoàn 920', instructorIds: ['INS-010', 'INS-018'], studentIds: STUDENT_IDS_BANK.slice(40, 53), totalSeats: 14, enrolledSeats: 13, progress: 100, passRate: 84.6 },
]

export const COURSES_BY_ID = Object.fromEntries(COURSES.map((c) => [c.id, c]))

// =============== Students (Học viên) ===============

export interface CompetencyScore {
  flightSkills: number
  navigation: number
  combatTactics: number
  emergencyHandling: number
  communication: number
  weaponDelivery: number
  teamCoordination: number
  decisionMaking: number
}

export interface ModuleProgress {
  moduleId: string
  moduleName: string
  status: 'Hoàn thành' | 'Đang học' | 'Chưa học' | 'Trượt'
  hoursCompleted: number
  hoursTotal: number
  sortiesCompleted: number
  sortiesTotal: number
  grade?: 'A' | 'B' | 'C' | 'D' | 'F'
  completedDate?: string
}

export interface Student {
  id: string
  code: string
  rank: string
  fullName: string
  dob: string
  enrollDate: string
  expectedGraduation: string
  unitId: string
  unitName: string
  courseId: string
  courseCode: string
  curriculumId: string
  status: StudentStatus
  totalHours: number
  hoursAccumulated: number
  totalSorties: number
  sortiesAccumulated: number
  overallGrade: 'A' | 'B' | 'C' | 'D' | 'F' | '-'
  competency: CompetencyScore
  moduleProgress: ModuleProgress[]
  attendance: number
  simulatorHours: number
  realFlightHours: number
  warnings: number
  achievements: string[]
  notes?: string
}

const VN_FAMILY_NAMES = ['Nguyễn', 'Trần', 'Lê', 'Phạm', 'Hoàng', 'Đặng', 'Bùi', 'Đỗ', 'Hồ', 'Vũ']
const VN_MIDDLE = ['Văn', 'Đức', 'Quang', 'Minh', 'Hữu', 'Quốc', 'Anh', 'Thanh']
const VN_GIVEN = ['Tuấn', 'Hùng', 'Nam', 'Long', 'Phong', 'Sơn', 'Trung', 'Khoa', 'Hải', 'Bình', 'Khánh', 'Vinh', 'Thắng', 'Chiến', 'Tùng', 'Cường', 'Tâm', 'Đông', 'Việt', 'Phú']

function vnName(seed: number): string {
  const f = VN_FAMILY_NAMES[seed % VN_FAMILY_NAMES.length]
  const m = VN_MIDDLE[(seed * 3) % VN_MIDDLE.length]
  const g = VN_GIVEN[(seed * 7) % VN_GIVEN.length]
  return `${f} ${m} ${g}`
}

const RANKS = ['Trung úy', 'Thượng úy', 'Đại úy']

function makeStudent(idx: number, course: Course, curriculum: Curriculum): Student {
  const seed = idx + 1
  const code = `STD-${String(idx + 1).padStart(3, '0')}`
  const rank = RANKS[idx % RANKS.length]
  const fullName = vnName(seed)
  const ageBase = 24 + (idx % 8)
  const dob = `${2026 - ageBase}-${String((seed % 12) + 1).padStart(2, '0')}-${String((seed % 27) + 1).padStart(2, '0')}`
  const status: StudentStatus = course.status === 'Đã kết thúc' ? (idx % 11 === 0 ? 'Loại' : 'Tốt nghiệp') : course.status === 'Sắp mở' ? 'Đang học' : (idx % 23 === 0 ? 'Đình chỉ' : idx % 17 === 0 ? 'Tạm nghỉ' : 'Đang học')

  const baseScore = 65 + ((seed * 13) % 30)
  const competency: CompetencyScore = {
    flightSkills: Math.min(98, baseScore + (seed % 7)),
    navigation: Math.min(98, baseScore + ((seed * 3) % 9) - 2),
    combatTactics: Math.min(98, baseScore + ((seed * 5) % 11) - 4),
    emergencyHandling: Math.min(98, baseScore + ((seed * 7) % 8) - 1),
    communication: Math.min(98, baseScore + ((seed * 11) % 6)),
    weaponDelivery: Math.min(98, baseScore + ((seed * 13) % 10) - 3),
    teamCoordination: Math.min(98, baseScore + ((seed * 17) % 7)),
    decisionMaking: Math.min(98, baseScore + ((seed * 19) % 9) - 2),
  }

  const moduleProgress: ModuleProgress[] = curriculum.modules.map((m, mi) => {
    const idxRatio = course.progress / 100
    const moduleEnd = (mi + 1) / curriculum.modules.length
    const moduleStart = mi / curriculum.modules.length
    let status: ModuleProgress['status']
    let hoursCompleted = 0
    let sortiesCompleted = 0
    let grade: ModuleProgress['grade'] | undefined
    let completedDate: string | undefined

    if (idxRatio >= moduleEnd) {
      status = 'Hoàn thành'
      hoursCompleted = m.hours
      sortiesCompleted = m.sorties || 0
      const gradeRoll = (seed + mi) % 10
      grade = gradeRoll < 2 ? 'A' : gradeRoll < 6 ? 'B' : gradeRoll < 9 ? 'C' : 'D'
      const monthsAgo = (1 - moduleEnd) * curriculum.durationMonths
      const dt = new Date(2026, 4, 1)
      dt.setMonth(dt.getMonth() - Math.floor(monthsAgo))
      completedDate = dt.toISOString().slice(0, 10)
    } else if (idxRatio > moduleStart) {
      status = 'Đang học'
      const moduleProg = (idxRatio - moduleStart) / (moduleEnd - moduleStart)
      hoursCompleted = Math.floor(m.hours * moduleProg)
      sortiesCompleted = Math.floor((m.sorties || 0) * moduleProg)
    } else {
      status = 'Chưa học'
    }

    return {
      moduleId: m.id, moduleName: m.name, status,
      hoursCompleted, hoursTotal: m.hours, sortiesCompleted, sortiesTotal: m.sorties || 0,
      grade, completedDate,
    }
  })

  const hoursAccumulated = moduleProgress.reduce((s, m) => s + m.hoursCompleted, 0)
  const sortiesAccumulated = moduleProgress.reduce((s, m) => s + m.sortiesCompleted, 0)

  const overallGradeRoll = (baseScore - 60) / 38
  const overallGrade: Student['overallGrade'] = status === 'Loại' ? 'F' : status === 'Đình chỉ' ? '-' : course.status === 'Sắp mở' ? '-' : overallGradeRoll > 0.85 ? 'A' : overallGradeRoll > 0.6 ? 'B' : overallGradeRoll > 0.35 ? 'C' : 'D'

  const achievements: string[] = []
  if (overallGrade === 'A') achievements.push('Bằng danh dự')
  if (competency.flightSkills > 92) achievements.push('Phi công xuất sắc')
  if (competency.weaponDelivery > 92) achievements.push('Tay súng giỏi')

  return {
    id: code, code, rank, fullName, dob,
    enrollDate: course.startDate,
    expectedGraduation: course.endDate,
    unitId: course.unitId, unitName: course.unitName,
    courseId: course.id, courseCode: course.code,
    curriculumId: curriculum.id, status,
    totalHours: curriculum.totalHours, hoursAccumulated,
    totalSorties: curriculum.totalSorties, sortiesAccumulated,
    overallGrade, competency, moduleProgress,
    attendance: 88 + ((seed * 11) % 12),
    simulatorHours: Math.floor(hoursAccumulated * 0.3),
    realFlightHours: Math.floor(hoursAccumulated * 0.7),
    warnings: status === 'Đình chỉ' ? 3 : status === 'Tạm nghỉ' ? 2 : (seed % 13 === 0 ? 1 : 0),
    achievements,
    notes: status === 'Loại' ? 'Không đạt yêu cầu sau 3 lần kiểm tra' : status === 'Đình chỉ' ? 'Vi phạm kỷ luật' : undefined,
  }
}

export const STUDENTS: Student[] = []
COURSES.forEach((c) => {
  const cur = CURRICULA_BY_ID[c.curriculumId]
  if (!cur) return
  c.studentIds.forEach((sid) => {
    const idx = parseInt(sid.replace('STD-', '')) - 1
    STUDENTS.push(makeStudent(idx, c, cur))
  })
})

export const STUDENTS_BY_ID = Object.fromEntries(STUDENTS.map((s) => [s.id, s]))

// =============== Instructors (Giảng viên) ===============

export interface Instructor {
  id: string
  code: string
  rank: string
  fullName: string
  unitId: string
  unitName: string
  qualifications: AircraftType[]
  totalFlightHours: number
  instructorHours: number
  yearsOfExperience: number
  rating: number // 0-5
  coursesTaught: number
  studentsTaught: number
  specializations: string[]
}

const INSTRUCTOR_DATA: Partial<Instructor>[] = [
  { qualifications: ['Su-30MK2', 'Su-22M4'], totalFlightHours: 4200, instructorHours: 1850, yearsOfExperience: 18, rating: 4.8, coursesTaught: 14, studentsTaught: 168, specializations: ['Bay tiến công', 'Bay đêm'] },
  { qualifications: ['Su-30MK2'], totalFlightHours: 3500, instructorHours: 1200, yearsOfExperience: 14, rating: 4.7, coursesTaught: 11, studentsTaught: 132, specializations: ['Bay biên đội', 'Tiếp dầu'] },
  { qualifications: ['Su-30MK2', 'MiG-21'], totalFlightHours: 5100, instructorHours: 2400, yearsOfExperience: 22, rating: 4.9, coursesTaught: 20, studentsTaught: 240, specializations: ['Bay tiến công không-đối-không', 'Đào tạo cao cấp'] },
  { qualifications: ['Su-22M4', 'MiG-21'], totalFlightHours: 3800, instructorHours: 1500, yearsOfExperience: 16, rating: 4.6, coursesTaught: 12, studentsTaught: 144, specializations: ['Tiến công mặt đất'] },
  { qualifications: ['Su-22M4'], totalFlightHours: 2900, instructorHours: 950, yearsOfExperience: 12, rating: 4.5, coursesTaught: 9, studentsTaught: 108, specializations: ['Chuyển loại'] },
  { qualifications: ['MiG-21'], totalFlightHours: 4500, instructorHours: 2100, yearsOfExperience: 19, rating: 4.7, coursesTaught: 15, studentsTaught: 180, specializations: ['Bay cơ bản'] },
  { qualifications: ['MiG-21', 'L-39'], totalFlightHours: 3200, instructorHours: 1100, yearsOfExperience: 13, rating: 4.4, coursesTaught: 10, studentsTaught: 130, specializations: ['Bay đêm'] },
  { qualifications: ['Yak-130', 'L-39'], totalFlightHours: 2800, instructorHours: 1300, yearsOfExperience: 11, rating: 4.6, coursesTaught: 8, studentsTaught: 112, specializations: ['Đào tạo trung gian'] },
  { qualifications: ['Yak-130'], totalFlightHours: 2200, instructorHours: 880, yearsOfExperience: 9, rating: 4.5, coursesTaught: 7, studentsTaught: 98, specializations: ['Bay cơ bản'] },
  { qualifications: ['L-39'], totalFlightHours: 3100, instructorHours: 1600, yearsOfExperience: 14, rating: 4.7, coursesTaught: 13, studentsTaught: 182, specializations: ['Vào nghề'] },
  { qualifications: ['L-39'], totalFlightHours: 2400, instructorHours: 1100, yearsOfExperience: 10, rating: 4.4, coursesTaught: 8, studentsTaught: 112, specializations: ['Bay vòng', 'Cất hạ cánh'] },
  { qualifications: ['Mi-17', 'Mi-8'], totalFlightHours: 3700, instructorHours: 1700, yearsOfExperience: 17, rating: 4.8, coursesTaught: 11, studentsTaught: 88, specializations: ['SAR', 'Bay treo'] },
  { qualifications: ['Mi-17'], totalFlightHours: 2600, instructorHours: 1050, yearsOfExperience: 12, rating: 4.5, coursesTaught: 7, studentsTaught: 56, specializations: ['Vận tải', 'Hạ cánh khẩn cấp'] },
  { qualifications: ['C-295'], totalFlightHours: 3300, instructorHours: 1400, yearsOfExperience: 14, rating: 4.7, coursesTaught: 4, studentsTaught: 24, specializations: ['Vận tải tầm xa', 'SIGINT'] },
  { qualifications: ['C-295'], totalFlightHours: 2800, instructorHours: 1100, yearsOfExperience: 11, rating: 4.6, coursesTaught: 3, studentsTaught: 18, specializations: ['Tuần thám biển'] },
  { qualifications: ['Su-30MK2'], totalFlightHours: 3000, instructorHours: 800, yearsOfExperience: 10, rating: 4.3, coursesTaught: 6, studentsTaught: 72, specializations: ['Bay đêm'] },
  { qualifications: ['MiG-21'], totalFlightHours: 2700, instructorHours: 700, yearsOfExperience: 9, rating: 4.4, coursesTaught: 5, studentsTaught: 55, specializations: ['Mô phỏng'] },
  { qualifications: ['L-39'], totalFlightHours: 1900, instructorHours: 600, yearsOfExperience: 8, rating: 4.2, coursesTaught: 4, studentsTaught: 56, specializations: ['Mô phỏng'] },
]

export const INSTRUCTORS: Instructor[] = INSTRUCTOR_DATA.map((d, i) => ({
  id: `INS-${String(i + 1).padStart(3, '0')}`,
  code: `INS-${String(i + 1).padStart(3, '0')}`,
  rank: i < 6 ? 'Đại tá' : i < 12 ? 'Trung tá' : 'Thiếu tá',
  fullName: vnName(i * 23 + 1000),
  unitId: `unit-tdb-${(i % 6) + 1}`,
  unitName: ['Trung đoàn 923', 'Trung đoàn 921', 'Trung đoàn 925', 'Trung đoàn 920', 'Lữ đoàn 916', 'Lữ đoàn 918'][i % 6],
  ...d,
} as Instructor))

export const INSTRUCTORS_BY_ID = Object.fromEntries(INSTRUCTORS.map((i) => [i.id, i]))

// =============== Simulator Sessions ===============

export type SimulatorType = 'Full Flight Sim Su-30' | 'Full Flight Sim MiG-21' | 'Mô phỏng Yak-130' | 'Mô phỏng L-39' | 'Mô phỏng Mi-17' | 'Mô phỏng C-295' | 'PC Trainer'
export type ScenarioType = 'Cất hạ cánh' | 'Bay vòng' | 'Bay biên đội' | 'Bay đêm' | 'Tiến công không-đối-không' | 'Tiến công không-đối-đất' | 'Xử lý sự cố' | 'Bay thời tiết phức tạp' | 'SAR'

export interface SimulatorSession {
  id: string
  code: string
  studentId: string
  studentName: string
  instructorId: string
  instructorName: string
  simulatorType: SimulatorType
  scenarioType: ScenarioType
  scenarioName: string
  date: string
  durationMinutes: number
  score: number // 0-100
  status: 'Hoàn thành' | 'Đang chạy' | 'Lập lịch' | 'Hoãn'
  emergencyEvents: number
  fuelEfficiency: number
  weaponAccuracy?: number
  notes?: string
}

const SCENARIOS: { type: ScenarioType; names: string[] }[] = [
  { type: 'Cất hạ cánh', names: ['Cất cánh ngày', 'Hạ cánh ngày', 'Cất hạ cánh thời tiết tốt'] },
  { type: 'Bay vòng', names: ['Bay vòng tay phải', 'Bay vòng tay trái', 'Bay vòng IFR'] },
  { type: 'Bay biên đội', names: ['Biên đội đôi cơ bản', 'Biên đội 4 chiếc', 'Đổi đội hình'] },
  { type: 'Bay đêm', names: ['Cất cánh đêm', 'Hạ cánh đêm có đèn', 'Bay đêm theo IFR'] },
  { type: 'Tiến công không-đối-không', names: ['Đánh chặn 1v1', 'Đánh chặn 2v2', 'Phòng tránh tên lửa'] },
  { type: 'Tiến công không-đối-đất', names: ['Tiến công bunker', 'Tiến công xe tăng', 'Tiến công cầu'] },
  { type: 'Xử lý sự cố', names: ['Cháy động cơ', 'Hỏng càng', 'Mất áp suất buồng lái', 'Hỏng radar'] },
  { type: 'Bay thời tiết phức tạp', names: ['Bay vào sương mù', 'Bay qua giông', 'Bay tầm nhìn thấp'] },
  { type: 'SAR', names: ['Tìm kiếm trên biển', 'Bốc người trên núi', 'Thả thiết bị cấp cứu'] },
]

const SIM_TYPES: SimulatorType[] = ['Full Flight Sim Su-30', 'Full Flight Sim MiG-21', 'Mô phỏng Yak-130', 'Mô phỏng L-39', 'Mô phỏng Mi-17', 'Mô phỏng C-295', 'PC Trainer']

export const SIMULATOR_SESSIONS: SimulatorSession[] = []
for (let i = 0; i < 36; i++) {
  const scn = SCENARIOS[i % SCENARIOS.length]
  const scenarioName = scn.names[i % scn.names.length]
  const student = STUDENTS[i % STUDENTS.length]
  const instructor = INSTRUCTORS[i % INSTRUCTORS.length]
  const daysAgo = Math.floor(i / 4)
  const dt = new Date(2026, 4, 7)
  dt.setDate(dt.getDate() - daysAgo)
  dt.setHours(7 + ((i * 3) % 12), (i * 13) % 60, 0)
  const status: SimulatorSession['status'] = i < 3 ? 'Đang chạy' : i > 30 ? 'Lập lịch' : 'Hoàn thành'
  const score = status === 'Hoàn thành' ? 60 + ((i * 7) % 40) : 0

  SIMULATOR_SESSIONS.push({
    id: `SIM-${String(i + 1).padStart(4, '0')}`,
    code: `SIM-${String(i + 1).padStart(4, '0')}`,
    studentId: student.id, studentName: student.fullName,
    instructorId: instructor.id, instructorName: instructor.fullName,
    simulatorType: SIM_TYPES[i % SIM_TYPES.length],
    scenarioType: scn.type, scenarioName,
    date: dt.toISOString(),
    durationMinutes: 60 + ((i * 11) % 90),
    score,
    status,
    emergencyEvents: scn.type === 'Xử lý sự cố' ? 2 + (i % 3) : i % 5 === 0 ? 1 : 0,
    fuelEfficiency: 75 + ((i * 5) % 23),
    weaponAccuracy: scn.type.includes('Tiến công') ? 65 + ((i * 9) % 30) : undefined,
    notes: status === 'Hoàn thành' && score < 70 ? 'Cần luyện tập thêm' : status === 'Hoàn thành' && score > 90 ? 'Xuất sắc' : undefined,
  })
}

// =============== Telemetry samples (cho 1 session) ===============

export interface TelemetryFrame {
  t: number // seconds
  altitude: number // ft
  airspeed: number // kts
  pitch: number // deg
  roll: number // deg
  heading: number // deg
  fuel: number // kg
  gForce: number
}

export function generateTelemetry(durationMinutes: number = 60): TelemetryFrame[] {
  const frames: TelemetryFrame[] = []
  const samples = durationMinutes * 6 // 1 frame / 10s
  for (let i = 0; i < samples; i++) {
    const t = i * 10
    const phase = i / samples
    const climbPhase = Math.min(1, phase * 4)
    const altitude = phase < 0.15 ? 12000 * climbPhase : phase < 0.85 ? 11000 + Math.sin(phase * Math.PI * 6) * 2000 : 12000 * (1 - (phase - 0.85) / 0.15)
    const airspeed = phase < 0.05 ? 150 + 600 * phase / 0.05 : phase < 0.95 ? 420 + Math.sin(phase * Math.PI * 8) * 80 : 200 + (180 * (1 - (phase - 0.95) / 0.05))
    const pitch = phase < 0.1 ? 15 - phase * 100 : Math.sin(phase * Math.PI * 12) * 8
    const roll = Math.sin(phase * Math.PI * 7) * 30 + (phase > 0.4 && phase < 0.6 ? 60 : 0) * Math.sin(phase * Math.PI * 30)
    const heading = (phase * 720) % 360
    const fuel = 4500 - phase * 3200
    const gForce = 1 + Math.abs(Math.sin(phase * Math.PI * 9)) * 4 + (phase > 0.4 && phase < 0.6 ? 3 : 0)

    frames.push({
      t,
      altitude: Math.max(0, Math.round(altitude)),
      airspeed: Math.round(airspeed),
      pitch: parseFloat(pitch.toFixed(1)),
      roll: parseFloat(roll.toFixed(1)),
      heading: Math.round(heading),
      fuel: Math.round(fuel),
      gForce: parseFloat(gForce.toFixed(2)),
    })
  }
  return frames
}

// =============== Certificates ===============

export interface TrainingCertificate {
  id: string
  code: string
  studentId: string
  studentName: string
  certificateCode: string
  certificateName: string
  curriculumId: string
  issueDate: string
  expireDate?: string
  issuedBy: string
  signatureBy: string
  status: 'Còn hiệu lực' | 'Hết hạn' | 'Bị thu hồi' | 'Đang gia hạn'
  hours: number
  finalScore: number
  grade: 'A' | 'B' | 'C' | 'D'
}

export const CERTIFICATES: TrainingCertificate[] = []
STUDENTS.filter((s) => s.status === 'Tốt nghiệp').forEach((s, i) => {
  const cur = CURRICULA_BY_ID[s.curriculumId]
  if (!cur) return
  const issueDt = new Date(s.expectedGraduation)
  const expireDt = new Date(issueDt)
  expireDt.setFullYear(expireDt.getFullYear() + 3)
  CERTIFICATES.push({
    id: `CERT-${String(i + 1).padStart(4, '0')}`,
    code: `CERT-${String(i + 1).padStart(4, '0')}`,
    studentId: s.id, studentName: s.fullName,
    certificateCode: cur.certificateCode,
    certificateName: `Chứng chỉ ${cur.name}`,
    curriculumId: cur.id,
    issueDate: issueDt.toISOString().slice(0, 10),
    expireDate: expireDt.toISOString().slice(0, 10),
    issuedBy: 'Trường Sĩ quan Không quân',
    signatureBy: 'Đại tá Nguyễn Văn A',
    status: i % 9 === 0 ? 'Hết hạn' : i % 13 === 0 ? 'Đang gia hạn' : 'Còn hiệu lực',
    hours: cur.totalHours,
    finalScore: 70 + ((i * 7) % 28),
    grade: s.overallGrade as 'A' | 'B' | 'C' | 'D',
  })
})

// =============== Materials (Tài liệu) ===============

export interface TrainingMaterial {
  id: string
  code: string
  title: string
  category: 'Giáo trình' | 'Bài giảng' | 'Video' | 'Cẩm nang kỹ thuật' | 'Quy chế' | 'Bài kiểm tra'
  aircraftType?: AircraftType
  curriculumId?: string
  classification: 'MẬT' | 'TUYỆT MẬT' | 'TỐI MẬT' | 'KHÔNG MẬT'
  fileSize: string
  format: 'PDF' | 'DOCX' | 'MP4' | 'PPTX' | 'ZIP'
  uploadedBy: string
  uploadDate: string
  views: number
  downloads: number
}

export const MATERIALS: TrainingMaterial[] = [
  { id: 'MAT-001', code: 'MAT-001', title: 'Giáo trình Su-30MK2 — Cấu tạo & Hệ thống', category: 'Giáo trình', aircraftType: 'Su-30MK2', curriculumId: 'CUR-001', classification: 'MẬT', fileSize: '124 MB', format: 'PDF', uploadedBy: 'Đại tá Nguyễn Văn A', uploadDate: '2025-08-20', views: 348, downloads: 87 },
  { id: 'MAT-002', code: 'MAT-002', title: 'Cẩm nang bay Su-30MK2 (TM-100)', category: 'Cẩm nang kỹ thuật', aircraftType: 'Su-30MK2', classification: 'TỐI MẬT', fileSize: '256 MB', format: 'PDF', uploadedBy: 'Trung tá Lê Văn B', uploadDate: '2025-08-25', views: 512, downloads: 134 },
  { id: 'MAT-003', code: 'MAT-003', title: 'Bài giảng — Bay tiến công không-đối-không', category: 'Bài giảng', aircraftType: 'Su-30MK2', curriculumId: 'CUR-001', classification: 'MẬT', fileSize: '48 MB', format: 'PPTX', uploadedBy: 'Đại tá Trần Văn C', uploadDate: '2025-09-10', views: 287, downloads: 76 },
  { id: 'MAT-004', code: 'MAT-004', title: 'Video — Cất hạ cánh Su-30MK2 chuẩn', category: 'Video', aircraftType: 'Su-30MK2', classification: 'KHÔNG MẬT', fileSize: '1.2 GB', format: 'MP4', uploadedBy: 'Trung tá Hoàng Văn D', uploadDate: '2025-09-15', views: 642, downloads: 201 },
  { id: 'MAT-005', code: 'MAT-005', title: 'Giáo trình MiG-21 cơ bản', category: 'Giáo trình', aircraftType: 'MiG-21', curriculumId: 'CUR-003', classification: 'MẬT', fileSize: '98 MB', format: 'PDF', uploadedBy: 'Đại tá Phạm Văn E', uploadDate: '2024-09-01', views: 423, downloads: 112 },
  { id: 'MAT-006', code: 'MAT-006', title: 'Cẩm nang bay MiG-21', category: 'Cẩm nang kỹ thuật', aircraftType: 'MiG-21', classification: 'TỐI MẬT', fileSize: '180 MB', format: 'PDF', uploadedBy: 'Trung tá Đỗ Văn F', uploadDate: '2024-09-05', views: 389, downloads: 98 },
  { id: 'MAT-007', code: 'MAT-007', title: 'Bài kiểm tra cuối khóa Su-30MK2', category: 'Bài kiểm tra', aircraftType: 'Su-30MK2', curriculumId: 'CUR-001', classification: 'MẬT', fileSize: '6 MB', format: 'DOCX', uploadedBy: 'Đại tá Nguyễn Văn A', uploadDate: '2025-12-01', views: 156, downloads: 45 },
  { id: 'MAT-008', code: 'MAT-008', title: 'Quy chế đào tạo phi công 2025', category: 'Quy chế', classification: 'KHÔNG MẬT', fileSize: '3 MB', format: 'PDF', uploadedBy: 'TMT QC', uploadDate: '2025-01-10', views: 891, downloads: 312 },
  { id: 'MAT-009', code: 'MAT-009', title: 'Giáo trình Yak-130', category: 'Giáo trình', aircraftType: 'Yak-130', curriculumId: 'CUR-004', classification: 'MẬT', fileSize: '76 MB', format: 'PDF', uploadedBy: 'Trung tá Hoàng Văn D', uploadDate: '2025-10-15', views: 198, downloads: 54 },
  { id: 'MAT-010', code: 'MAT-010', title: 'Video — Xử lý sự cố cháy động cơ', category: 'Video', classification: 'KHÔNG MẬT', fileSize: '480 MB', format: 'MP4', uploadedBy: 'Trung tá Vũ Văn G', uploadDate: '2025-11-20', views: 245, downloads: 68 },
  { id: 'MAT-011', code: 'MAT-011', title: 'Cẩm nang Yak-130', category: 'Cẩm nang kỹ thuật', aircraftType: 'Yak-130', classification: 'MẬT', fileSize: '124 MB', format: 'PDF', uploadedBy: 'Trung tá Hoàng Văn D', uploadDate: '2025-10-18', views: 156, downloads: 42 },
  { id: 'MAT-012', code: 'MAT-012', title: 'Bài giảng — Bay đêm IFR', category: 'Bài giảng', classification: 'MẬT', fileSize: '32 MB', format: 'PPTX', uploadedBy: 'Đại tá Trần Văn C', uploadDate: '2025-12-15', views: 178, downloads: 53 },
  { id: 'MAT-013', code: 'MAT-013', title: 'Giáo trình Mi-17 trực thăng', category: 'Giáo trình', aircraftType: 'Mi-17', curriculumId: 'CUR-006', classification: 'MẬT', fileSize: '92 MB', format: 'PDF', uploadedBy: 'Đại tá Bùi Văn H', uploadDate: '2025-07-20', views: 167, downloads: 47 },
  { id: 'MAT-014', code: 'MAT-014', title: 'Video — Bay biên đội 4 chiếc', category: 'Video', classification: 'MẬT', fileSize: '780 MB', format: 'MP4', uploadedBy: 'Đại tá Nguyễn Văn A', uploadDate: '2026-01-10', views: 89, downloads: 21 },
  { id: 'MAT-015', code: 'MAT-015', title: 'Bài giảng — SAR cứu nạn đường không', category: 'Bài giảng', aircraftType: 'Mi-17', classification: 'MẬT', fileSize: '24 MB', format: 'PPTX', uploadedBy: 'Đại tá Bùi Văn H', uploadDate: '2025-12-20', views: 134, downloads: 38 },
  { id: 'MAT-016', code: 'MAT-016', title: 'Tổng hợp checklist Pre-flight tất cả loại MB', category: 'Cẩm nang kỹ thuật', classification: 'KHÔNG MẬT', fileSize: '8 MB', format: 'PDF', uploadedBy: 'TMT QC', uploadDate: '2026-02-01', views: 678, downloads: 234 },
  { id: 'MAT-017', code: 'MAT-017', title: 'Bài kiểm tra MiG-21 cuối khóa', category: 'Bài kiểm tra', aircraftType: 'MiG-21', curriculumId: 'CUR-003', classification: 'MẬT', fileSize: '5 MB', format: 'DOCX', uploadedBy: 'Đại tá Phạm Văn E', uploadDate: '2026-03-15', views: 78, downloads: 23 },
  { id: 'MAT-018', code: 'MAT-018', title: 'Quy chế an toàn bay HL 2026', category: 'Quy chế', classification: 'KHÔNG MẬT', fileSize: '2 MB', format: 'PDF', uploadedBy: 'TMT QC', uploadDate: '2026-01-15', views: 1245, downloads: 478 },
  { id: 'MAT-019', code: 'MAT-019', title: 'Giáo trình C-295 vận tải', category: 'Giáo trình', aircraftType: 'C-295', curriculumId: 'CUR-007', classification: 'MẬT', fileSize: '156 MB', format: 'PDF', uploadedBy: 'Đại tá Lê Văn I', uploadDate: '2025-06-15', views: 87, downloads: 24 },
  { id: 'MAT-020', code: 'MAT-020', title: 'Video — Thả thiết bị cấp cứu (Mi-17)', category: 'Video', aircraftType: 'Mi-17', classification: 'KHÔNG MẬT', fileSize: '320 MB', format: 'MP4', uploadedBy: 'Đại tá Bùi Văn H', uploadDate: '2026-02-25', views: 56, downloads: 14 },
]

// =============== Schedule (Lịch huấn luyện) ===============

export interface ScheduleItem {
  id: string
  courseId: string
  courseCode: string
  date: string
  startTime: string
  endTime: string
  type: 'Lý thuyết' | 'Mô phỏng' | 'Bay thực' | 'Kiểm tra' | 'AAR'
  title: string
  studentIds: string[]
  instructorId: string
  instructorName: string
  location: string
  status: 'Đã lên lịch' | 'Đang diễn ra' | 'Hoàn thành' | 'Hủy' | 'Hoãn'
}

export const SCHEDULE: ScheduleItem[] = []
for (let i = 0; i < 60; i++) {
  const course = COURSES[i % COURSES.length]
  if (course.status !== 'Đang mở') continue
  const dt = new Date(2026, 4, 7)
  dt.setDate(dt.getDate() + ((i % 14) - 7))
  const types: ScheduleItem['type'][] = ['Lý thuyết', 'Mô phỏng', 'Bay thực', 'Kiểm tra', 'AAR']
  const t = types[i % types.length]
  const startHour = 7 + ((i * 3) % 10)
  const dur = t === 'Bay thực' ? 2 : t === 'Mô phỏng' ? 1.5 : 1
  const today = new Date(2026, 4, 7)
  const status: ScheduleItem['status'] = dt < today ? 'Hoàn thành' : dt.toDateString() === today.toDateString() ? (i % 7 === 0 ? 'Đang diễn ra' : 'Đã lên lịch') : 'Đã lên lịch'

  SCHEDULE.push({
    id: `SCH-${String(i + 1).padStart(4, '0')}`,
    courseId: course.id, courseCode: course.code,
    date: dt.toISOString().slice(0, 10),
    startTime: `${String(startHour).padStart(2, '0')}:00`,
    endTime: `${String(Math.floor(startHour + dur)).padStart(2, '0')}:${dur % 1 ? '30' : '00'}`,
    type: t,
    title: `${t} — ${course.name}`,
    studentIds: course.studentIds.slice(0, 4),
    instructorId: course.instructorIds[0],
    instructorName: INSTRUCTORS_BY_ID[course.instructorIds[0]]?.fullName || 'N/A',
    location: t === 'Lý thuyết' ? 'Phòng học A1.05' : t === 'Mô phỏng' ? 'Phòng MP-2' : t === 'Bay thực' ? 'Sân bay Phú Cát' : 'Phòng họp B',
    status,
  })
}

// =============== Assessments (Đánh giá năng lực định kỳ) ===============

export interface Assessment {
  id: string
  studentId: string
  studentName: string
  courseId: string
  assessmentDate: string
  assessmentType: 'Giữa kỳ' | 'Cuối kỳ' | 'Đột xuất' | 'Tốt nghiệp'
  evaluatorId: string
  evaluatorName: string
  scores: CompetencyScore
  overall: number
  passed: boolean
  remarks: string
}

export const ASSESSMENTS: Assessment[] = []
STUDENTS.slice(0, 30).forEach((s, i) => {
  const overall = Math.round((Object.values(s.competency).reduce((a, b) => a + b, 0)) / 8)
  ASSESSMENTS.push({
    id: `ASS-${String(i + 1).padStart(4, '0')}`,
    studentId: s.id, studentName: s.fullName,
    courseId: s.courseId,
    assessmentDate: new Date(2026, 4 - (i % 6), (i % 27) + 1).toISOString().slice(0, 10),
    assessmentType: i % 4 === 0 ? 'Cuối kỳ' : i % 4 === 1 ? 'Giữa kỳ' : i % 4 === 2 ? 'Đột xuất' : 'Tốt nghiệp',
    evaluatorId: INSTRUCTORS[i % INSTRUCTORS.length].id,
    evaluatorName: INSTRUCTORS[i % INSTRUCTORS.length].fullName,
    scores: s.competency,
    overall,
    passed: overall >= 70,
    remarks: overall >= 90 ? 'Học viên xuất sắc, tiến bộ vượt bậc' : overall >= 75 ? 'Đạt yêu cầu, tiếp tục phấn đấu' : overall >= 65 ? 'Cần luyện tập thêm các kỹ năng yếu' : 'Không đạt yêu cầu, cần xem xét',
  })
})

// =============== KPIs ===============

export const TRAINING_KPIS = {
  totalStudents: STUDENTS.length,
  activeStudents: STUDENTS.filter((s) => s.status === 'Đang học').length,
  graduatedThisYear: STUDENTS.filter((s) => s.status === 'Tốt nghiệp').length,
  totalInstructors: INSTRUCTORS.length,
  activeCourses: COURSES.filter((c) => c.status === 'Đang mở').length,
  totalSimulatorHours: STUDENTS.reduce((s, st) => s + st.simulatorHours, 0),
  totalRealFlightHours: STUDENTS.reduce((s, st) => s + st.realFlightHours, 0),
  averagePassRate: 87.4,
  averageGrade: 'B+',
  certificatesIssued: CERTIFICATES.length,
  budgetUsed: 78,
  curriculaActive: CURRICULA.length,
}
